import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=c68c997c&"
import script from "./Target.vue?vue&type=script&lang=js&"
export * from "./Target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports